import React from 'react';
import styles from './PageHeader.module.css';

export const PageHeader = function(props) {
  return (
    <div
      className={`container-fluid d-flex justify-content-between align-items-center pt-3 pb-2 ps-0 pe-0  mb-3 ${styles.StyleDiv}`}
    >
      <h4 className="page-title text-muted">{props.title}</h4>
      {props.children}
      {window.innerWidth > 768 && <div>{props.breadCrumbs}</div>}
    </div>
  );
};
